import _isNull from 'lodash/isNull'

export const addOnStockNormalizer = value => {
  if (_isNull(value)) {
    return 'Unlimited'
  }
  return Number(value)
}
